
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
}

export const TermsModal: React.FC<TermsModalProps> = ({ open, onClose }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{t('terms_title')}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 text-sm text-muted-foreground">
          <h3 className="font-bold mt-4 text-foreground">{t('privacy_policy_title')}</h3>
          <p>{t('privacy_policy_last_updated')}</p>
          <p>
            {t('privacy_policy_intro')}
          </p>
          <p>
            {t('privacy_policy_consent')}
          </p>

          <h3 className="font-bold mt-4 text-foreground">{t('information_we_collect_title')}</h3>
          <p>
            {t('information_we_collect_desc1')}
          </p>
          <p>
            {t('information_we_collect_desc2')}
          </p>
          <p>
            {t('information_we_collect_desc3')}
          </p>

          <h3 className="font-bold mt-4 text-foreground">{t('how_we_use_title')}</h3>
          <p>
            {t('how_we_use_desc1')}
          </p>
          <p>
            {t('how_we_use_desc2')}
          </p>

          <h3 className="font-bold mt-4 text-foreground">{t('disclosure_information_title')}</h3>
          <p>
            {t('disclosure_information_desc')}
          </p>

          <h3 className="font-bold mt-4 text-foreground">{t('healthcare_responsibilities_title')}</h3>
          <p>
            {t('healthcare_responsibilities_desc')}
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>{t('healthcare_responsibilities_list1')}</li>
            <li>{t('healthcare_responsibilities_list2')}</li>
            <li>{t('healthcare_responsibilities_list3')}</li>
          </ul>

          <h3 className="font-bold mt-4 text-foreground">{t('changes_policy_title')}</h3>
          <p>
            {t('changes_policy_desc')}
          </p>
        </div>
        <div className="flex justify-end pt-4 border-t">
          <Button onClick={onClose} className="px-6">
            {t('close')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
